(function () {
  // Cache DOM elements
  const elements = {
    sizeBtn: document.querySelector('.size-guide__btn'),
    sizePop: document.querySelector('.size-guide__popup'),
    sizeBg: document.querySelector('.size-guide__background'),
    sizeClsBtn: document.querySelector('.size-guide__close'),
    sizeTabs: document.querySelectorAll('.size-guide__tab'),
    productMeasurements: document.querySelector('.product-measurements'),
    sizeConversionChart: document.querySelector('.size-conversion-chart'),
    sizeUnit: document.querySelectorAll('.product-measurements__size-unit'),
    sizeOptions: document.querySelectorAll('.product-measurements__size-option'),
    scrubLinks: document.querySelectorAll('.scrubs_select'),
    images: document.querySelectorAll('.individual_size_guide_image'),
    conversionUnitSelect: document.getElementById('conversion-unit-select'),
    conversionCountrySelect: document.getElementById('conversion-country-select'),
    measurementsCountrySelect: document.getElementById('measurements-country-select'),
    sizeOptionsContainer: document.querySelector('.product-measurements__size-options'),
    dynamicSizeList: document.getElementById('dynamic-size-list'),
    conversionTable: document.getElementById('conversion-table'),
    tableHeader: document.getElementById('table-header')
  };

  // State management
  const state = {
    sizeGuideData: null,
    currentGroup: '',
    currentSize: '',
    currentUnit: 'cm',
    currentProductIndex: 0,
    isMetafieldData: false,
    currentCountry: 'au/uk'
  };

  // Size mapping for different countries
  // Handles both numeric sizes (AU/UK) and letter sizes
  const countryMapping = {
    // Numeric sizes (AU/UK as base)
    '4': { 'au/uk': '4', 'us': '0', 'fr/sp': '32', 'gm': '34', 'it': '36', 'cn': '2XS', 'jp': '5' },
    '6': { 'au/uk': '6', 'us': '2', 'fr/sp': '34', 'gm': '36', 'it': '38', 'cn': 'XS', 'jp': '7' },
    '8': { 'au/uk': '8', 'us': '4', 'fr/sp': '36', 'gm': '38', 'it': '40', 'cn': 'S', 'jp': '9' },
    '10': { 'au/uk': '10', 'us': '6', 'fr/sp': '38', 'gm': '40', 'it': '42', 'cn': 'M', 'jp': '11' },
    '12': { 'au/uk': '12', 'us': '8', 'fr/sp': '40', 'gm': '42', 'it': '44', 'cn': 'L', 'jp': '13' },
    '14': { 'au/uk': '14', 'us': '10', 'fr/sp': '42', 'gm': '44', 'it': '46', 'cn': 'XL', 'jp': '15' },
    '16': { 'au/uk': '16', 'us': '12', 'fr/sp': '44', 'gm': '46', 'it': '48', 'cn': '2XL', 'jp': '17' },
    '18': { 'au/uk': '18', 'us': '14', 'fr/sp': '46', 'gm': '48', 'it': '50', 'cn': '3XL', 'jp': '19' },
    '20': { 'au/uk': '20', 'us': '16', 'fr/sp': '48', 'gm': '50', 'it': '52', 'cn': '4XL', 'jp': '21' },
    // Letter sizes
    '3XS': { 'au/uk': '4', 'us': '0', 'fr/sp': '32', 'gm': '34', 'it': '36', 'cn': '2XS', 'jp': '5' },
    '2XS': { 'au/uk': '6', 'us': '2', 'fr/sp': '34', 'gm': '36', 'it': '38', 'cn': '1XS', 'jp': '7' },
    'XS': { 'au/uk': '8', 'us': '4', 'fr/sp': '36', 'gm': '38', 'it': '40', 'cn': 'S', 'jp': '9' },
    'S': { 'au/uk': '10', 'us': '6', 'fr/sp': '38', 'gm': '40', 'it': '42', 'cn': 'M', 'jp': '11' },
    'M': { 'au/uk': '12', 'us': '8', 'fr/sp': '40', 'gm': '42', 'it': '44', 'cn': 'L', 'jp': '13' },
    'L': { 'au/uk': '14', 'us': '10', 'fr/sp': '42', 'gm': '44', 'it': '46', 'cn': 'XL', 'jp': '15' },
    'XL': { 'au/uk': '16', 'us': '12', 'fr/sp': '44', 'gm': '46', 'it': '48', 'cn': '2XL', 'jp': '17' },
    '2XL': { 'au/uk': '18', 'us': '14', 'fr/sp': '46', 'gm': '48', 'it': '50', 'cn': '3XL', 'jp': '19' },
    'XXL': { 'au/uk': '18', 'us': '14', 'fr/sp': '46', 'gm': '48', 'it': '50', 'cn': '3XL', 'jp': '19' },
    '3XL': { 'au/uk': '20', 'us': '16', 'fr/sp': '48', 'gm': '50', 'it': '52', 'cn': '4XL', 'jp': '21' },
    'XXXL': { 'au/uk': '20', 'us': '16', 'fr/sp': '48', 'gm': '50', 'it': '52', 'cn': '4XL', 'jp': '21' }
  };

  // Utility functions
  const utils = {
    getRootGroup() {
      if (elements.sizePop?.dataset.source === 'metafield') {
        return 'metafield';
      }
      return elements.sizePop?.dataset.productType;
    },

    convertValue(value, fromUnit, toUnit) {
      if (fromUnit === 'cm' && toUnit === 'inches') return (value / 2.54).toFixed(1);
      if (fromUnit === 'inches' && toUnit === 'cm') return (value * 2.54).toFixed(1);
      return value;
    },

    getDefaultSizeFromDOM() {
      const firstOption = document.querySelector('.product-measurements__size-option.selected');
      return firstOption?.dataset.size?.toUpperCase();
    },

    createElement(tag, className, textContent) {
      const element = document.createElement(tag);
      if (className) element.className = className;
      if (textContent) element.textContent = textContent;
      return element;
    },

    toggleDisplay(element, show, displayType = 'block') {
      if (element) element.style.display = show ? displayType : 'none';
    },

    removeClassFromAll(nodeList, className) {
      nodeList.forEach(el => el.classList.remove(className));
    },

    addClassToMatching(nodeList, className, matcher) {
      nodeList.forEach(el => {
        if (matcher(el)) el.classList.add(className);
      });
    },

    getSizeLabel(originalSize, country) {
      // Convert to string and handle the size
      let sizeStr = String(originalSize).trim();
      
      // Try uppercase for letter sizes
      const upperSize = sizeStr.toUpperCase();
      
      // Check if this is a letter size (XS, S, M, L, XL, 2XL, 3XL, 2XS, 3XS, XXL, XXXL)
      const letterSizes = ['3XS', '2XS', 'XS', 'S', 'M', 'L', 'XL', '2XL', 'XXL', '3XL', 'XXXL'];
      if (letterSizes.includes(upperSize) && country === 'au/uk') {
        // Keep letter sizes as letters when country is AU/UK - don't convert them
        return upperSize;
      }
      
      // For all other cases (numeric sizes or letter sizes with other countries), apply country mapping
      if (countryMapping[sizeStr]) {
        const label = countryMapping[sizeStr][country] || originalSize;
        return label;
      } else if (countryMapping[upperSize]) {
        const label = countryMapping[upperSize][country] || originalSize;
        return label;
      }
      
      return originalSize;
    }
  };

  // Rendering functions
  const renderer = {
    createMeasurementItem(key, value) {
      const container = utils.createElement('div', 'product-sizing-details__size-item');
      const label = utils.createElement('span', 'product-sizing-details__item-label', 
        key.charAt(0).toUpperCase() + key.slice(1));
      
      const valueWrapper = utils.createElement('div', 'product-measurements__size-values');
      const valueSpan = utils.createElement('span', 'product-sizing-details__size-value');
      
      valueSpan.dataset.measurement = key.toLowerCase();
      
      let displayValue = value;
      if (typeof value === 'number' && state.currentUnit === 'inches') {
        displayValue = utils.convertValue(value, 'cm', 'inches');
      }
      
      valueSpan.textContent = displayValue;
      
      const unitLabel = utils.createElement('span', 'product-sizing-details__size-unit-label', 
        state.currentUnit === 'cm' ? ' cm' : ' inches');
      
      valueWrapper.appendChild(valueSpan);
      valueWrapper.appendChild(unitLabel);
      container.appendChild(label);
      container.appendChild(valueWrapper);
      
      return container;
    },

    renderMetafieldSizeList(size) {
      if (!state.sizeGuideData?.products?.[state.currentProductIndex]) return;
      
      const currentProduct = state.sizeGuideData.products[state.currentProductIndex];
      const selectedSize = currentProduct.sizes?.find(s => 
        s.name?.toUpperCase() === size?.toUpperCase());
      
      if (selectedSize?.measures) {
        selectedSize.measures.forEach(measure => {
          Object.entries(measure).forEach(([key, value]) => {
            elements.dynamicSizeList.appendChild(this.createMeasurementItem(key, value));
          });
        });
      }
    },

    renderOriginalSizeList(size) {
      const rootGroup = utils.getRootGroup();
      
      if (rootGroup === 'scrub' && !state.currentGroup) {
        state.currentGroup = 'scrub_top';
      } else if (rootGroup !== 'scrub') {
        state.currentGroup = '';
      }

      const measurements = rootGroup === 'scrub'
        ? state.sizeGuideData[rootGroup]?.[state.currentGroup]?.measurements
        : state.sizeGuideData[rootGroup]?.measurements;

      if (!Array.isArray(measurements)) {
        return;
      }

      measurements.forEach(item => {
        const sizeEntry = Array.isArray(item.size_guide)
          ? item.size_guide.find(s => s.size?.toUpperCase() === size?.toUpperCase())
          : undefined;

        let value = sizeEntry?.value ?? '--';
        if (typeof value === 'number' && state.currentUnit === 'inches') {
          value = utils.convertValue(value, 'cm', 'inches');
        }

        elements.dynamicSizeList.appendChild(this.createMeasurementItem(item.name, value));
      });
    },

    renderSizeList(size = state.currentSize || utils.getDefaultSizeFromDOM()) {
      if (!elements.dynamicSizeList || !state.sizeGuideData) return;

      elements.dynamicSizeList.innerHTML = '';
      
      if (utils.getRootGroup() === 'metafield') {
        this.renderMetafieldSizeList(size);
      } else {
        this.renderOriginalSizeList(size);
      }
    },

    renderConversionTable() {
      if (!elements.conversionTable || !state.sizeGuideData) return;

      const rootGroup = utils.getRootGroup();
      elements.conversionTable.innerHTML = '';

      if (rootGroup === 'metafield') {
        this.renderMetafieldConversionTable();
      } else {
        this.renderOriginalConversionTable(rootGroup);
      }
    },

    renderMetafieldConversionTable() {
      if (!state.sizeGuideData?.products?.[state.currentProductIndex]) return;
      
      const currentProduct = state.sizeGuideData.products[state.currentProductIndex];
      
      if (currentProduct.sizes?.length > 0) {
        // Get all unique measurement names
        const allMeasurements = new Set();
        currentProduct.sizes.forEach(size => {
          if (size.measures) {
            size.measures.forEach(measure => {
              Object.keys(measure).forEach(key => allMeasurements.add(key));
            });
          }
        });

        // Clear and populate the table header
        if (elements.tableHeader) {
          elements.tableHeader.innerHTML = '';
          const measurementHeader = utils.createElement('th', '', 'Measurements');
          measurementHeader.setAttribute('colspan', '2');
          elements.tableHeader.appendChild(measurementHeader);

          currentProduct.sizes.forEach(size => {
            // Get the size label based on current country
            const sizeLabel = utils.getSizeLabel(size.name.toUpperCase(), state.currentCountry);
            const sizeHeader = utils.createElement('th', '', sizeLabel);
            elements.tableHeader.appendChild(sizeHeader);
          });
        } else {
          // Fallback: add header row to tbody if thead not found
          const headerRow = utils.createElement('tr');
          const measurementHeader = utils.createElement('th', '', 'Measurements');
          measurementHeader.setAttribute('colspan', '2');
          headerRow.appendChild(measurementHeader);

          currentProduct.sizes.forEach(size => {
            // Get the size label based on current country
            const sizeLabel = utils.getSizeLabel(size.name.toUpperCase(), state.currentCountry);
            const sizeHeader = utils.createElement('th', '', sizeLabel);
            headerRow.appendChild(sizeHeader);
          });
          elements.conversionTable.appendChild(headerRow);
        }

        // Create rows for each measurement
        allMeasurements.forEach(measurementName => {
          const row = utils.createElement('tr');
          const labelCell = utils.createElement('td', '', 
            measurementName.charAt(0).toUpperCase() + measurementName.slice(1));
          labelCell.setAttribute('colspan', '2');
          row.appendChild(labelCell);

          currentProduct.sizes.forEach(size => {
            const cell = utils.createElement('td');
            let value = '--';

            if (size.measures) {
              const measurementObj = size.measures.find(measure => 
                Object.keys(measure).includes(measurementName)
              );
              if (measurementObj) {
                value = measurementObj[measurementName];
                if (typeof value === 'number' && state.currentUnit === 'inches') {
                  value = utils.convertValue(value, 'cm', 'inches');
                }
              }
            }

            cell.textContent = value;
            row.appendChild(cell);
          });

          elements.conversionTable.appendChild(row);
        });
      }
    },

    renderOriginalConversionTable(rootGroup) {
      const measurements = rootGroup === 'scrub'
        ? state.sizeGuideData[rootGroup]?.[state.currentGroup]?.measurements
        : state.sizeGuideData[rootGroup]?.measurements;

      if (!Array.isArray(measurements)) return;

      const sizes = measurements[0]?.size_guide?.map(entry => entry.size) || [];

      measurements.forEach(measurement => {
        const row = utils.createElement('tr');
        const labelCell = utils.createElement('td', '', 
          measurement.name.charAt(0).toUpperCase() + measurement.name.slice(1));
        labelCell.setAttribute('colspan', '2');
        row.appendChild(labelCell);

        sizes.forEach(size => {
          const cell = utils.createElement('td');
          const entry = measurement.size_guide.find(s => 
            s.size?.toUpperCase() === size?.toUpperCase());
          let value = entry?.value ?? '--';

          if (typeof value === 'number' && state.currentUnit === 'inches') {
            value = utils.convertValue(value, 'cm', 'inches');
          }

          cell.textContent = value;
          row.appendChild(cell);
        });

        elements.conversionTable.appendChild(row);
      });
    }
  };

  // Main functions
  function updateAllDisplays() {
    renderer.renderSizeList(state.currentSize);
    renderer.renderConversionTable();
  }

  function syncUnitSelectors(newUnit) {
    state.currentUnit = newUnit;
    
    // Update product measurements unit buttons
    utils.removeClassFromAll(elements.sizeUnit, 'selected');
    const matchingUnitButton = document.querySelector(`[data-size-unit="${newUnit}"]`);
    if (matchingUnitButton) matchingUnitButton.classList.add('selected');
    
    // Update conversion chart dropdown
    if (elements.conversionUnitSelect) elements.conversionUnitSelect.value = newUnit;
    
    updateAllDisplays();
  }

  function updateSizeOptions(productIndex) {
    if (!elements.sizeOptionsContainer || !state.sizeGuideData?.products?.[productIndex]) return;
    
    elements.sizeOptionsContainer.innerHTML = '';
    const currentProduct = state.sizeGuideData.products[productIndex];
    
    currentProduct.sizes.forEach((size, index) => {
      // Get the display label based on selected country
      const displayLabel = utils.getSizeLabel(size.name, state.currentCountry);
      const sizeOption = utils.createElement('span', 
        `product-measurements__size-option${index === 0 ? ' selected' : ''}`, 
        displayLabel);
      sizeOption.dataset.size = size.name.toUpperCase();
      sizeOption.dataset.originalSize = size.name;
      elements.sizeOptionsContainer.appendChild(sizeOption);
    });

    // Re-attach event listeners to new size options
    attachSizeOptionListeners();
    
    // Set current size to first size of new product
    state.currentSize = currentProduct.sizes[0]?.name?.toUpperCase();
  }

  function updateSizeOptionsDisplay() {
    // Update existing size option labels based on current country
    const sizeOptions = document.querySelectorAll('.product-measurements__size-option');
    sizeOptions.forEach(option => {
      const originalSize = option.dataset.originalSize || option.dataset.size;
      if (originalSize) {
        const displayLabel = utils.getSizeLabel(originalSize, state.currentCountry);
        option.textContent = displayLabel;
      }
    });
  }

  // Event listeners
  function attachSizeOptionListeners() {
    const sizeOptions = document.querySelectorAll('.product-measurements__size-option');
    sizeOptions.forEach(option => {
      option.addEventListener('click', () => {
        utils.removeClassFromAll(sizeOptions, 'selected');
        option.classList.add('selected');
        state.currentSize = option.dataset.size.toUpperCase();
        updateAllDisplays();
      });
    });
  }

  function handleScrubLinkClick(link) {
    // Handle metafield product selection
    if (utils.getRootGroup() === 'metafield' && link.dataset.productIndex !== undefined) {
      state.currentProductIndex = parseInt(link.dataset.productIndex);
      
      // Update selected state for all scrub selects
      utils.removeClassFromAll(document.querySelectorAll('.scrubs_select'), 'selected');
      utils.addClassToMatching(document.querySelectorAll('.scrubs_select'), 'selected', 
        el => el.dataset.productIndex === link.dataset.productIndex);

      // Update image visibility based on selected product type
      const selectedType = link.textContent.trim().toUpperCase();
      utils.removeClassFromAll(elements.images, 'selected');
      utils.addClassToMatching(elements.images, 'selected', 
        img => img.dataset.imageType?.trim().toUpperCase() === selectedType);

      updateSizeOptions(state.currentProductIndex);
      updateAllDisplays();
      return;
    }

    // Handle original scrub selection
    if (link.classList.contains('scrub_pant')) {
      state.currentGroup = 'scrub_pant';
    } else if (link.classList.contains('scrub_top')) {
      state.currentGroup = 'scrub_top';
    } else if (link.classList.contains('scrub_jacket')) {
      state.currentGroup = 'scrub_jacket';
    }

    updateAllDisplays();
  }

  function initializeEventListeners() {
    // Size guide modal controls
    elements.sizeBtn?.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      elements.sizePop.style.display = 'flex';
      elements.sizeBg.style.display = 'block';
    });

    const closeModal = () => {
      elements.sizePop.style.display = 'none';
      elements.sizeBg.style.display = 'none';
    };

    elements.sizeClsBtn?.addEventListener('click', closeModal);
    elements.sizeBg?.addEventListener('click', closeModal);

    // Tab switching
    elements.sizeTabs.forEach(tab => {
      tab.addEventListener('click', () => {
        utils.removeClassFromAll(elements.sizeTabs, 'active');
        tab.classList.add('active');

        const tabType = tab.getAttribute('data-tab');
        
        if (tabType === 'measurements') {
          utils.toggleDisplay(elements.productMeasurements, true, 'flex');
          utils.toggleDisplay(elements.sizeConversionChart, false);
        } else if (tabType === 'conversion') {
          utils.toggleDisplay(elements.productMeasurements, false);
          utils.toggleDisplay(elements.sizeConversionChart, true, 'block');
        }
      });
    });

    // Unit selection (product measurements)
    elements.sizeUnit.forEach(unit => {
      unit.addEventListener('click', () => {
        if (unit.classList.contains('selected')) return;
        syncUnitSelectors(unit.dataset.sizeUnit);
      });
    });

    // Unit selection (conversion chart dropdown)
    elements.conversionUnitSelect?.addEventListener('change', (e) => {
      syncUnitSelectors(e.target.value);
    });

    // Country selection (conversion chart dropdown)
    elements.conversionCountrySelect?.addEventListener('change', (e) => {
      e.stopPropagation(); // Prevent event from bubbling to VariantSelects
      state.currentCountry = e.target.value;
      // Sync with measurements country selector
      if (elements.measurementsCountrySelect) {
        elements.measurementsCountrySelect.value = state.currentCountry;
      }
      updateAllDisplays();
      updateSizeOptionsDisplay();
    });

    // Country selection (measurements tab dropdown)
    elements.measurementsCountrySelect?.addEventListener('change', (e) => {
      e.stopPropagation(); // Prevent event from bubbling to VariantSelects
      state.currentCountry = e.target.value;
      // Sync with conversion country selector
      if (elements.conversionCountrySelect) {
        elements.conversionCountrySelect.value = state.currentCountry;
      }
      updateAllDisplays();
      updateSizeOptionsDisplay();
    });

    // Size options
    attachSizeOptionListeners();

    // Scrub links
    elements.scrubLinks.forEach(link => {
      link.addEventListener('click', () => handleScrubLinkClick(link));
    });
  }
  // Initialize the application
  function init() {
    // Check if we have metafield data
    state.isMetafieldData = elements.sizePop?.dataset.source === 'metafield';

    // Set initial country from dropdown if it exists
    if (elements.conversionCountrySelect) {
      state.currentCountry = elements.conversionCountrySelect.value || 'au/uk';
    }
    
    // Sync both country selectors
    if (elements.measurementsCountrySelect) {
      elements.measurementsCountrySelect.value = state.currentCountry;
    }

    if (state.isMetafieldData && window.metafieldSizeData) {
      // Use metafield data directly
      state.sizeGuideData = window.metafieldSizeData;
      state.currentSize = utils.getDefaultSizeFromDOM();
      updateAllDisplays();
      updateSizeOptionsDisplay();
    }
    
    // Set up event listeners regardless of data source
    initializeEventListeners();
    
    // Subscribe to variant changes to sync size selection
    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        if (event?.data?.variant?.option1) {
          // Get the selected size from the variant
          const selectedSize = event.data.variant.option1;
          
          // Update the current size in state
          state.currentSize = selectedSize.toUpperCase();
          
          // Update the selected size option in the size guide
          const sizeOptions = document.querySelectorAll('.product-measurements__size-option');
          sizeOptions.forEach(option => {
            if (option.dataset.size === selectedSize || option.dataset.size === selectedSize.toUpperCase()) {
              // Remove selected from all options
              utils.removeClassFromAll(sizeOptions, 'selected');
              // Add selected to matching option
              option.classList.add('selected');
            }
          });
          
          // Update the displays
          updateAllDisplays();
        }
      });
    }
  }

  // Start the application
  init();
})();